export const groupBy = <T>(array: T[], key: (i: T) => string): Record<string, T[]> =>
  array.reduce(
    (groups: Record<string, T[]>, item: T) => {
      (groups[key(item)] ||= []).push(item);
      return groups;
    },
    {} as Record<string, T[]>,
  );
